import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface MyStoryProps {
  aboutText: string;
}

const MyStory: React.FC<MyStoryProps> = ({ aboutText }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Split about text into paragraphs
  const aboutParagraphs = aboutText.split('\n\n');
  const firstParagraph = aboutParagraphs[0];
  const remainingParagraphs = aboutParagraphs.slice(1);

  return (
    <div className="mt-8">
      <h2 className="text-lg font-light text-black mb-4">My Story</h2>
      <div className="text-gray-600 pl-4 sm:pl-0">
        <p className="mb-4 text-sm">{firstParagraph}</p>
        <div className="relative">
          <div 
            className={`overflow-hidden transition-all duration-[500ms] ease-in-out ${
              isExpanded ? 'max-h-[1000px]' : 'max-h-[80px]'
            }`}
          >
            {remainingParagraphs.map((paragraph, index) => (
              <p key={index} className="mb-4 text-sm">{paragraph}</p>
            ))}
          </div>
          <div 
            className={`absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white via-white to-transparent transition-opacity duration-[500ms] ease-in-out pointer-events-none ${
              isExpanded ? 'opacity-0' : 'opacity-100'
            }`}
          />
        </div>
        <button 
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors -mt-2 group relative z-10"
        >
          <span className="text-xs font-normal">{isExpanded ? 'Show less' : 'Read more'}</span>
          <ChevronDown 
            className={`w-5 h-5 transition-transform duration-[500ms] ease-in-out ${
              isExpanded ? 'rotate-180' : ''
            } group-hover:translate-y-0.5`}
          />
        </button>
      </div>
    </div>
  );
};

export default MyStory; 